// Purpose: admin dropbox-approval API wrappers. Includes Phase 7 bulk
// approve/deny routes.

import { api, csrfHeaders } from './client.ts';

export interface ApprovalRequester {
  id: string;
  email: string;
  displayName: string;
}

export interface ApprovalDropbox {
  id: string;
  label: string | null;
  type: 'EPHEMERAL' | 'PERSISTENT';
  status: string;
  maxFiles: number;
  maxSizeBytes: string;
  deleteOnRetrieve: boolean;
}

export interface ApprovalEntry {
  id: string;
  dropboxId: string;
  requestedAt: string;
  justification: string;
  requester: ApprovalRequester | null;
  dropbox: ApprovalDropbox | null;
}

export interface ApprovalApproveResponse {
  dropboxId: string;
  linkUrl: string;
  expiresAt: string;
}

export async function listPendingApprovals(): Promise<ApprovalEntry[]> {
  const res = await api.get<{ approvals: ApprovalEntry[] }>('/admin/dropbox-approvals');
  return res.data.approvals;
}

export async function approveApproval(
  id: string,
  input: { expiresAt: string; note?: string }
): Promise<ApprovalApproveResponse> {
  const res = await api.post<ApprovalApproveResponse>(
    `/admin/dropbox-approvals/${id}/approve`,
    input,
    { headers: csrfHeaders() }
  );
  return res.data;
}

export async function denyApproval(id: string, reason: string): Promise<void> {
  await api.post(`/admin/dropbox-approvals/${id}/deny`, { reason }, { headers: csrfHeaders() });
}

export interface BulkApprovedEntry {
  approvalId: string;
  dropboxId: string;
  linkUrl: string;
}

export async function bulkApproveApprovals(input: {
  approvalIds: string[];
  expiresAt: string;
  note?: string;
}): Promise<BulkApprovedEntry[]> {
  const res = await api.post<{ approved: BulkApprovedEntry[] }>(
    '/admin/dropbox-approvals/bulk-approve',
    input,
    { headers: csrfHeaders() }
  );
  return res.data.approved;
}

export async function bulkDenyApprovals(input: {
  approvalIds: string[];
  reason: string;
}): Promise<void> {
  await api.post('/admin/dropbox-approvals/bulk-deny', input, { headers: csrfHeaders() });
}
